export default function App() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-950 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary-600/20 to-accent-600/10"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 bg-primary-500/20 text-primary-300 text-xs font-semibold rounded-full uppercase tracking-wide border border-primary-400/20">
              随时随地追剧
            </span>
            <h2 className="mt-4 text-2xl md:text-3xl font-bold text-background-50">桔子视频 · 移动端畅享体验</h2>
            <p className="mt-4 text-background-200/80 text-sm md:text-base leading-relaxed max-w-lg mx-auto lg:mx-0">
              告别电脑束缚，桔子视频全面适配手机与平板。无论您是通勤路上、午休间隙还是睡前放松，
              打开浏览器即可畅享西瓜视频、丝瓜视频的高清内容。移动端专属优化，流量消耗更低、加载速度更快。
            </p>
            <div className="mt-6 flex flex-wrap gap-3 justify-center lg:justify-start">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50/10 rounded-full border border-background-300/20">
                <i className="ri-smartphone-line text-primary-300 text-lg"></i>
                <span className="text-xs text-background-200 font-medium">手机适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50/10 rounded-full border border-background-300/20">
                <i className="ri-tablet-line text-accent-300 text-lg"></i>
                <span className="text-xs text-background-200 font-medium">平板优化</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50/10 rounded-full border border-background-300/20">
                <i className="ri-wifi-line text-secondary-300 text-lg"></i>
                <span className="text-xs text-background-200 font-medium">省流模式</span>
              </div>
            </div>
            <div className="mt-6">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <i className="ri-compass-3-line"></i>
                立即体验移动版
              </a>
            </div>
          </div>
          <div className="flex-1 max-w-xs lg:max-w-sm mx-auto">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/15 rounded-[2.5rem] blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20video%20streaming%20app%20interface%20with%20movie%20posters%20grid%20layout%2C%20warm%20orange%20theme%20UI%2C%20dark%20mode%20design%2C%20clean%20minimal%20interface%2C%20Chinese%20video%20platform%20mobile%20app%20screen%2C%20soft%20glow%20highlights&width=600&height=900&seq=juzi-app-mobile&orientation=portrait"
                alt="桔子视频移动端界面"
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}